<template>
    <div class="row">
        <div class="col-md-6">
            <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
                <div class="panel panel-primary heading-border">
                    <div class="panel-heading">
                        <span class="panel-title">
                            <i class="fa fa-pencil-square"></i>
                            Редактирование пользователя
                        </span>
                    </div>
                    <form @submit.prevent="saveUser">
                        <div class="panel-body p25">
                            <div class=" section row">

                                <div class="col-md-6">
                                    <label class="switch switch-primary">
                                        <input type="checkbox" id="form-user-status" v-model="$v.user.status.$model" value="10">
                                        <label for="form-user-status" data-on="Да" data-off="Нет"></label>
                                        <span>Активный</span>
                                    </label>
                                </div>
                            </div>
                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="field-label">Логин</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.user.login.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-user"></i></label>
                                    </label>
                                    <div v-if="$v.user.login.$error === true || forms.user.errors.login" class="error">
                                        {{ this.forms.user.errors.login ? this.forms.user.errors.login.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>
                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Имя</label>

                                    <label class="field prepend-icon">
                                        <input v-model="$v.user.firstName.$model" type="text" class="gui-input">
                                        <label class="field-icon">
                                            <i class="fa fa-user"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.user.firstName.$error === true || forms.user.errors.firstName" class="error">
                                        {{ this.forms.user.errors.firstName ? this.forms.user.errors.firstName.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <!-- end section -->

                                <div class="col-md-6">
                                    <label class="field-label">Фамилия</label>
                                    <label class="field prepend-icon">
                                        <input v-model="$v.user.lastName.$model" type="text" class="gui-input">
                                        <label class="field-icon">
                                            <i class="fa fa-user"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.user.lastName.$error === true || forms.user.errors.lastName" class="error">
                                        {{ this.forms.user.errors.lastName ? this.forms.user.errors.lastName.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <!-- end section -->
                            </div>
                            <!-- end section row section -->
                            <div class="section row">
                                <div class="col-md-6">

                                    <label class="field-label">Телефон</label>
                                    <label class="field prepend-icon">
                                        <input v-model="$v.user.phone.$model" type="tel" class="gui-input"
                                               placeholder="+7925">
                                        <label class="field-icon">
                                            <i class="fa fa-phone-square"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.user.phone.$error === true || forms.user.errors.phone" class="error">
                                        {{ this.forms.user.errors.phone ? this.forms.user.errors.phone.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <!-- end section -->
                                <div class="col-md-6">
                                    <label class="field-label">Дата рождения</label>
                                    <label class="field prepend-icon">
                                        <input v-model="$v.user.birthday.$model" type="date" class="gui-input">
                                        <label class="field-icon">
                                            <i class="fa  fa-calendar"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.user.birthday.$error === true || forms.user.errors.birthday" class="error">
                                        {{ this.forms.user.errors.birthday ? this.forms.user.errors.birthday.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="field-label">Email</label>
                                    <label class="field prepend-icon">
                                        <input v-model="$v.user.email.$model" type="email" class="gui-input"
                                               placeholder="example@domain.com...">
                                        <label class="field-icon">
                                            <i class="fa fa-envelope"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.user.email.$error === true || forms.user.errors.email" class="error">
                                        {{ this.forms.user.errors.email ? this.forms.user.errors.email.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Роль</label>
                                    <label class="field select">
                                        <select v-model="user.role">
                                            <option
                                                    v-for="role in data.roles"
                                                    v-bind:key="role.role"
                                                    :value="role.role"
                                            >
                                                {{role.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.user.role.$error === true || forms.user.errors.role" class="error">
                                        {{ this.forms.user.errors.role ? this.forms.user.errors.role.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Филиал</label>
                                    <label class="field select">
                                        <select v-model="user.filiationId">
                                            <option value="">Выберите филиал</option>
                                            <option
                                                    v-for="filiation in data.filiations"
                                                    v-bind:key="filiation.id"
                                                    :value="filiation.id"
                                            >
                                                {{filiation.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.user.filiationId.$error === true || forms.user.errors.filiation_id" class="error">
                                        {{ this.forms.user.errors.filiation_id ? this.forms.user.errors.filiation_id.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>
                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="field-label">Должность</label>
                                    <label class="field select">
                                        <select v-model="user.postId">
                                            <option value="0">Нет</option>
                                            <option
                                                    v-for="post in data.posts"
                                                    v-bind:key="post.id"
                                                    :value="post.id"
                                            >
                                                {{post.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.user.postId.$error === true || forms.user.errors.post_id" class="error">
                                        {{ this.forms.postId.errors.post_id ? this.forms.user.errors.post_id.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row mb25">
                                <div class="col-md-12">
                                    <label class="field-label">Комментарий</label>
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" v-model="$v.user.comment.$model"></textarea>
                                        <label class="field-icon">
                                            <i class="fa fa-edit"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary" :disabled="forms.user.isSubmitting">
                                Сохранить
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row">
                <div class="panel">
                    <div class="panel-heading">
                        <span class="panel-title">Смена пароля</span>
                        <span class="panel-controls"></span>
                    </div>
                    <form id="change_passwd">
                        <div class="panel-body">
                            <div class="col-md-6">
                                <div class="input-group ">
                                    <span class="input-group-addon">
                                        <i class="fa fa-key"></i>
                                    </span>
                                    <input class="form-control" type="password" v-model="$v.forms.password.password.$model" placeholder="Пароль"
                                           autocomplete="off">
                                </div>
                                <div v-if="$v.forms.password.password.$error === true || forms.password.errors.password" class="error">
                                    {{ this.forms.password.errors.password ? this.forms.password.errors.password.join(', ') : 'Введите верное значение' }}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="input-group">
                                    <span class="input-group-addon">
                                        <i class="fa fa-key"></i>
                                    </span>
                                    <input class="form-control" type="password" v-model="$v.forms.password.repeat.$model" placeholder="Подтверждение"
                                           autocomplete="off">
                                </div>
                                <div v-if="$v.forms.password.repeat.$error === true || forms.password.errors.repeat" class="error">
                                    {{ this.forms.password.errors.repeat ? this.forms.password.errors.repeat.join(', ') : 'Введите верное значение' }}
                                </div>
                            </div>
                        </div>
                        <div class="panel-menu">
                            <button type="submit" @click.prevent="savePassword" class="btn btn-primary mr10" :disabled="forms.password.isSubmitting">Сменить</button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="panel">
                    <div class="panel-heading">
                        <span class="panel-title">Аватар</span>
                        <span class="panel-controls"></span>
                    </div>
                    <form>
                        <div class="panel-body" v-if="user.avatar">
                            <div class="col-md-6 center-block text-center">
                                <img :src="user.avatar.image" style="max-width: 100%;">
                            </div>
                        </div>
                        <div class="panel-menu">
                            <div v-if="Object.keys(forms.avatar.errors).length > 0" class="error pb10">
                                {{ this.forms.avatar.errors.image.join(', ') }}
                            </div>
                            <label class="btn btn-primary mr10" :disabled="forms.avatar.isSubmitting">
                                <input type="file" class="hidden" v-on:change="saveAvatar">
                                <span class="glyphicon glyphicon-upload"></span>
                                Загрузить
                            </label>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import User from "../../models/User";
    import Filiation from "../../models/Filliation";
    import { required, email, minLength } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';
    import ValidationError from "../../classes/ValidationError";
    import UserPost from "../../models/UserPost";

    export default {
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {
            try {
                const user = await User.get(to.params.id);

                let filiationsResponse, userPostsResponse;
                [filiationsResponse, userPostsResponse] = await Promise.all([
                    Filiation.getList(1, 999),
                    UserPost.getList({}, 1, 'name', -1),
                ]);
                next(component => {
                    component.user = user;
                    component.data.filiations = filiationsResponse.data;
                    component.data.posts = userPostsResponse.data;

                    if (user.avatar) {
                        component.forms.avatar.image = user.avatar.image;
                    }
                });
            } catch (error) {
                next({
                    name: 'error',
                    path: to.fullPath,
                    params: {
                        code: error.response.status,
                        codeText: error.response.statusText,
                        message: error.response.data.message,
                        trace: error.response.data.type,
                    },
                })
            }
        },
        data() {
            return {
                data: {
                    filiations: [],
                    posts: [],
                    roles: [
                        {role: 'manager', name: 'Менеджер'},
                        {role: 'admin', name: 'Администратор'},
                    ],
                },
                user: new User({
                    status: User.STATUS_ACTIVE,
                    role: '',
                    filiationId: 0,
                    postId: 0,
                }),
                forms: {
                    user: {
                        isSubmitting: false,
                        errors: {},
                    },
                    password: {
                        isSubmitting: false,
                        errors: {},
                        password: '',
                        repeat: '',
                    },
                    avatar: {
                        isSubmitting: false,
                        upload: null,
                        errors: {},
                    },
                },
            };
        },
        validations: {
            user: {
                postId: {},
                login: {required},
                firstName: {required},
                lastName: {},
                phone: {},
                birthday: {},
                email: {email},
                comment: {},
                status: {},
                role: {},
                filiationId: {},
            },
            forms: {
                password: {
                    password: {required},
                    repeat: {
                        required: required,
                        minLength: minLength(6),
                    },
                },
            },
        },
        methods: {
            async saveUser() {
                this.$v.user.$touch();
                if (this.$v.user.$invalid) {
                    return false;
                }

                this.forms.user.isSubmitting = true;
                this.forms.user.errors = {};

                try {
                    await this.user.update();

                    if (this.user.id === this.$store.state.user.me.id) {
                        this.$store.commit('user/setMe', this.user);
                    }

                } catch (error) {
                    this.forms.user.errors = error.errors;
                }

                this.forms.user.isSubmitting = false;
            },
            async savePassword() {
                this.$v.forms.password.$touch();
                if (this.$v.forms.password.$invalid) {
                    return false;
                }
                this.forms.password.errors = {};
                this.forms.password.isSubmitting = true;

                try {
                    await this.user.updatePassword(this.forms.password.password, this.forms.password.repeat);
                    this.forms.password.password = '';
                    this.forms.password.repeat = '';
                } catch (error) {
                    if (error instanceof ValidationError) {
                        this.forms.password.errors = error.errors;
                    } else {
                        this.$notify({
                            type: 'error',
                            text: 'Ошибка изменения пароля'
                        });
                    }
                }

                this.forms.password.isSubmitting = false;
            },
            async saveAvatar(event) {
                this.forms.avatar.errors = {};
                this.forms.avatar.isSubmitting = true;
                const image = event.target.files[0];

                try {
                    await this.user.updateImage(image);
                    if (this.user.id === this.$store.state.user.me.id) {
                        this.$store.commit('user/setMe', this.user);
                    }
                } catch (error) {
                    if (error instanceof ValidationError) {
                        this.forms.avatar.errors = error.errors;
                    } else {
                        this.$notify({
                            type: 'error',
                            position: 'top middle',
                            text: 'Ошибка загрузки аватара'
                        });
                    }
                }

                this.forms.avatar.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Пользователи - редактирование',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>